import { getPhysicianBalances } from '@kikodacode/vbi-cares-api';
import { useQuery } from 'react-query';
import { PhysicianResult } from 'components/Modules/DataDisplay/PhysicianSearchGrid';
import { axiosInstance } from './axiosConfig';
import { queryKeys } from './constants';

export interface useProviderSearchProps {
  searchTerm?: string;
}

export const useProviderSearch = ({ searchTerm }: useProviderSearchProps) => {
  const criteria = preProcessSearchString(searchTerm);

  const { data, isLoading } = useQuery(
    queryKeys.physicians(criteria),
    async () => {
      return getPhysicianBalances(
        {
          physicianName: criteria.physicianName,
          licenseNumber: criteria.physicianLicense,
        },
        axiosInstance,
      );
    },
    {
      enabled: criteria.physicianLicense.length > 0 || criteria.physicianName.length > 0,
    },
  );
  // process data returned from lambda call
  const results: PhysicianResult[] =
    data?.data.map(item => {
      const name = item.fullName.split(',');
      return {
        id: item.physicianId.toString(),
        firstName: name[1] ?? '',
        lastName: name[0] ?? '',
        balance: item.amountDue,
        license: item.licenseNumber,
        statusId: Number(item.statusId),
        legalCanPay: item.legalCanPay,
        pendingPaymentStatus: item.pendingPaymentStatus,
        participating: item.participating,
      };
    }) ?? [];
  return { results, loading: isLoading };
};

const preProcessSearchString = (searchTerm?: string) => {
  const terms = searchTerm?.split(' ');
  const criteria = {
    physicianLicense: '',
    physicianName: '',
  };
  if (searchTerm && searchTerm?.length > 0) {
    terms?.forEach(x => {
      if (x.match(/\d+/g)) {
        criteria.physicianLicense = x;
      } else if (x.match(/[a-zA-Z]+/g)) {
        if (criteria.physicianName === '') {
          criteria.physicianName = x;
        } else {
          criteria.physicianName = `${x}, ${criteria.physicianName}`;
        }
      }
    });
  }
  return criteria;
};
